import { render, staticRenderFns } from "./IndexManageItem.vue?vue&type=template&id=3db4de8a&scoped=true"
import script from "./IndexManageItem.vue?vue&type=script&lang=js"
export * from "./IndexManageItem.vue?vue&type=script&lang=js"
import style0 from "./IndexManageItem.vue?vue&type=style&index=0&id=3db4de8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db4de8a",
  null
  
)

export default component.exports